import apiCompetitiveActivity from '@/api/competitive-activity'

const state = {
  data: [],
  isLoading: false,
  validationErrors: null,
}

export const mutationTypes = {
  getCompetitiveActivityStart:
    '[competitive activity] getCompetitiveActivityStart',
  getCompetitiveActivitySuccess:
    '[competitive activity] getCompetitiveActivitySuccess',
  getCompetitiveActivityFailure:
    '[competitive activity] getCompetitiveActivityFailure',
}

export const actionType = {
  getCompetitiveActivity: '[competitive activity] getCompetitiveActivity',
}

const mutations = {
  [mutationTypes.getCompetitiveActivityStart](state) {
    state.isLoading = true
    state.validationErrors = null
    state.data = []
  },

  [mutationTypes.getCompetitiveActivitySuccess](state, payload) {
    state.isLoading = false
    state.data = payload
  },

  [mutationTypes.getCompetitiveActivityFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.getCompetitiveActivity](context) {
    context.commit(mutationTypes.getCompetitiveActivityStart)
    return new Promise((resolve) => {
      apiCompetitiveActivity
        .getCompetitiveActivity()
        .then((response) => {
          context.commit(
            mutationTypes.getCompetitiveActivitySuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getCompetitiveActivityFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
